import * as React from 'react';
import * as moment from 'moment';

import { ListEventProps } from '../components/list/event';

const ListEventView: React.StatelessComponent<ListEventProps> = props => {
    const eventMoment = moment(props.event.eventDate);
    const uniqueA11yId = function (index) {
        return `${props.event.id}_buyTicketsA11y_${index}`;
    };
    const cssClasses = `ace-cal-list-event buy-tickets-list-item ${props.cssClass}`;
    return (
        <li className={cssClasses}>
            <article className="buy-tickets-list-content">
                <h3 className="ace-cal-list-day-date buy-tickets-date">{eventMoment.format("dddd, MMMM D")}</h3>
                <div className="buy-tickets-event-content">
                    <p className="ace-cal-list-event-time">{eventMoment.format("h:mm A")}</p>
                    <p className="ace-cal-list-event-venue">{props.event.location}</p>
                    {
                        props.event.optionalMessage.length > 0 ?
                            <div className="ace-cal-list-event-synopsis rich-text"><p>{props.event.optionalMessage}</p></div>
                            : ""
                    }
                    {
                        props.event.priceText.length > 0 && props.event.hidePricing === false ?
                            <p className="small">{props.event.priceText}</p>
                            : ""
                    }
                    {
                        props.event.accessibilityInfo.length > 0 ?
                            <ul className="buy-tickets-a11y">
                                {props.event.accessibilityInfo.map((a11y, index) =>
                                    <li className="buy-tickets-a11y-buttons" key={index}>
                                        <button key={index} className="btn-link" data-a11y-dialog-show={uniqueA11yId(index)}>{a11y.name}</button><div className="buy-tickets-a11y-icon"><img key={index} src={a11y.icon} alt="" /></div>
                                        <div id={uniqueA11yId(index)} data-modal className="dialog-container adage-modal-wrapper adage-themed theme-pink" aria-hidden="true">
                                            <div tabIndex={-1} data-a11y-dialog-hide="" className="adage-modal-overlay"></div>
                                            <div role="dialog" aria-labelledby="dialog-title-Touch tours available" className="adage-modal-dialog">
                                                <div className="adage-modal-inner">
                                                    <div className="adage-modal-header">
                                                        <h1 id="dialog-title-Touch tours available" tabIndex={-1} data-a11y-dialog-title="" className="adage-modal-heading-small">
                                                            {a11y.name}
                                                            <img className="adage-modal-heading-img" src={a11y.icon} alt=""/>
                                                        </h1>
                                                            <button type="button" data-a11y-dialog-hide="" aria-label="Close this dialog" className="adage-modal-close">
                                                                <svg dangerouslySetInnerHTML={{ __html: '<use xlink: href="#icon-close"></use>' }} />
                                                            </button>
                                                    </div>
                                                    <div className="rich-text" dangerouslySetInnerHTML={{ __html: a11y.modalDescription }}>                                               
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                )}
                            </ul>
                            : ""
                    }
                    <p className="ace-cal-list-event-cta"><a href={props.event.buyTicketCtaUrl} className="btn">{props.event.buyTicketCtaText}</a></p>
                </div>
            </article>
        </li>
    );
}

export default ListEventView;